document.addEventListener("DOMContentLoaded", function () {
  var footer = document.querySelector(".footer");
  var footerCta = document.querySelector(".footer-cta");
  if (footer && !footerCta) {
    footer.classList.add("footer-border-top-left-curve");
  }
});
